var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9831 1.14183C17.3616 2.96994 19.3013 6.65681 18.8937 10.4757C18.6445 12.961 17.4173 15.2452 15.4823 16.8253C13.5473 18.4053 11.0634 19.1514 8.57775 18.8993C4.75339 18.536 1.52709 15.8997 0.409893 12.2252C-0.707302 8.5506 0.505817 4.56533 3.48109 2.13584C6.45636 -0.293643 10.6047 -0.686276 13.9831 1.14183ZM2.56385 8.74994C2.1696 12.5502 4.92568 15.9536 8.72899 16.3632V16.3857C10.5768 16.572 12.423 16.0163 13.8601 14.8413C15.2972 13.6664 16.2072 11.9686 16.3893 10.1226C16.7519 6.31922 13.9675 2.93879 10.1609 2.56085C6.35432 2.18292 2.95811 4.94971 2.56385 8.74994Z",
    fill: "#4C4948"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5104 19.734L18.5553 15.2182L16.3125 17.6958L21.2513 22.1966C21.2768 22.2241 21.3034 22.2509 21.3311 22.277C22.003 22.9103 23.0407 22.8604 23.6488 22.1655C24.2569 21.4707 24.2052 20.394 23.5332 19.7606C23.5248 19.7527 23.5162 19.7448 23.5077 19.737L23.5104 19.734Z",
    fill: "#4C4948"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e61630ab7d38772c83d374ab42d823f8.svg";
export { ForwardRef as ReactComponent };